import { faqCusto, faqDados, faqProgramar } from './shared'
import type { ProfessionPageConfig } from './types'

export const advogados: ProfessionPageConfig = {
  path: '/ia-para-advogados/',
  key: 'advogados',
  title: 'IA para advogados e secretária jurídica | Oficina IA',
  description:
    'Três tarefas do escritório que a IA adianta numa pasta: a pasta do processo organizada, o andamento explicado ao cliente e a planilha de prazos.',
  imageAlt: 'Oficina IA: IA para advogados',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para advogados e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para advogados',
  intro:
    'Prazo, processo e cliente perguntando "e aí?". O escritório grande tem ferramenta cara; o pequeno tem o Word e a memória. Aqui estão três tarefas que a IA pode ajudar a adiantar, sem programar.',
  rogerio: { pose: 'pedindo-esclarecimento', text: 'Prazo é novelo que não espera. Eu ajudo a desenrolar.' },
  tasks: [
    {
      title: 'A pasta do processo organizada',
      tone: 'sky',
      brings: 'os arquivos do processo, do jeito que chegaram.',
      helps: 'renomeia por data e tipo e monta um índice.',
      continues: 'acha o que precisa sem abrir tudo.',
    },
    {
      title: 'Andamento em português para o cliente',
      tone: 'peach',
      brings: 'a última movimentação e o que vem depois.',
      helps: 'escreve o recado em linguagem simples, sem juridiquês.',
      continues: 'confere, ajusta e manda pelo WhatsApp.',
    },
    {
      title: 'Planilha de prazos',
      tone: 'sage',
      brings: 'as intimações da semana.',
      helps: 'monta a planilha com cada prazo e uma aba do que ficou em dúvida.',
      continues: 'confere um por um. Prazo é responsabilidade sua.',
    },
  ],
  steps: {
    do: 'A IA organiza a pasta, escreve o recado ou monta a planilha dentro da sua pasta.',
    check: 'Abra o que saiu e confira com o processo. A IA pode se enganar; a peça e o prazo são seus.',
    resume: 'Na semana seguinte, troque as intimações e repita o pedido.',
  },
  faq: [
    faqProgramar,
    {
      question: 'A IA vai escrever as minhas peças?',
      answer: 'Nas tarefas desta página, ela organiza, resume e prepara. O que vai para o processo é seu e passa pela sua revisão.',
    },
    faqDados('dos clientes'),
    faqCusto,
  ],
  closing: {
    title: 'Seu primeiro processo organizado, com alguém do lado.',
    text: 'Traga a pasta do processo, o andamento que o cliente pede ou a planilha de prazos.',
    rogerio: 'Eu cuido do novelo. Você cuida do prazo.',
  },
}
